// SPDX-License-Identifier: AGPL-3.0-or-later

import {msg} from '@lingui/core/macro';

export const SHOW_KEYBOARD_SHORTCUTS_LIST_DESCRIPTOR = msg({
	message: 'Show keybind list',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const EDIT_MESSAGE_DESCRIPTOR = msg({
	message: 'Edit message',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const EDIT_YOUR_MESSAGES_ABOVE_OR_BELOW_DESCRIPTOR = msg({
	message: 'Edit your messages above or below',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const PIN_MESSAGE_DESCRIPTOR = msg({
	message: 'Pin message',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const ADD_REACTION_DESCRIPTOR = msg({
	message: 'Add reaction',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const REPLY_TO_MESSAGE_DESCRIPTOR = msg({
	message: 'Reply to message',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const REPLY_TO_MESSAGES_ABOVE_OR_BELOW_DESCRIPTOR = msg({
	message: 'Reply to messages above or below',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const FORWARD_MESSAGE_DESCRIPTOR = msg({
	message: 'Forward message',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const READ_MESSAGE_ALOUD_DESCRIPTOR = msg({
	message: 'Read message aloud',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const MARK_AS_UNREAD_DESCRIPTOR = msg({
	message: 'Mark as unread',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const FOCUS_TEXT_AREA_DESCRIPTOR = msg({
	message: 'Focus text area',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const SWITCH_BETWEEN_COMMUNITIES_DESCRIPTOR = msg({
	message: 'Switch between communities',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const SWITCH_BETWEEN_CHANNELS_DESCRIPTOR = msg({
	message: 'Switch between channels',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const MOVE_BACK_THROUGH_VIEWED_CHANNEL_HISTORY_DESCRIPTOR = msg({
	message: 'Move back through viewed channel history',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const MOVE_FORWARD_THROUGH_VIEWED_CHANNEL_HISTORY_DESCRIPTOR = msg({
	message: 'Move forward through viewed channel history',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const JUMP_BETWEEN_UNREAD_CHANNELS_DESCRIPTOR = msg({
	message: 'Jump between unread channels',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const JUMP_BETWEEN_UNREAD_CHANNELS_WITH_MENTIONS_DESCRIPTOR = msg({
	message: 'Jump between unread channels with mentions',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const JUMP_TO_THE_CURRENT_CALL_DESCRIPTOR = msg({
	message: 'Jump to the current call',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const TOGGLE_BETWEEN_LAST_COMMUNITY_AND_DMS_DESCRIPTOR = msg({
	message: 'Toggle between last community and DMs',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const SWITCH_TO_PREVIOUS_COMMUNITY_OR_DMS_DESCRIPTOR = msg({
	message: 'Switch to previous community or DMs',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const SWITCH_TO_NEXT_COMMUNITY_OR_DMS_DESCRIPTOR = msg({
	message: 'Switch to next community or DMs',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const GO_TO_DIRECT_MESSAGES_DESCRIPTOR = msg({
	message: 'Go to direct messages',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const GO_TO_FIRST_COMMUNITY_DESCRIPTOR = msg({
	message: 'Go to first community',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const GO_TO_SECOND_COMMUNITY_DESCRIPTOR = msg({
	message: 'Go to second community',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const GO_TO_THIRD_COMMUNITY_DESCRIPTOR = msg({
	message: 'Go to third community',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const GO_TO_FOURTH_COMMUNITY_DESCRIPTOR = msg({
	message: 'Go to fourth community',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const GO_TO_FIFTH_COMMUNITY_DESCRIPTOR = msg({
	message: 'Go to fifth community',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const GO_TO_SIXTH_COMMUNITY_DESCRIPTOR = msg({
	message: 'Go to sixth community',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const GO_TO_SEVENTH_COMMUNITY_DESCRIPTOR = msg({
	message: 'Go to seventh community',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const GO_TO_EIGHTH_COMMUNITY_DESCRIPTOR = msg({
	message: 'Go to eighth community',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const TOGGLE_QUICK_SWITCHER_DESCRIPTOR = msg({
	message: 'Toggle quick switcher',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const CREATE_OR_JOIN_A_COMMUNITY_DESCRIPTOR = msg({
	message: 'Create or join a community',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const START_DRAG_AND_DROP_DESCRIPTOR = msg({
	message: 'Start drag and drop',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const MOVE_DESCRIPTOR = msg({
	message: 'Move',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const DROP_ITEM_DESCRIPTOR = msg({
	message: 'Drop item',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const CANCEL_DESCRIPTOR = msg({
	message: 'Cancel',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const MARK_COMMUNITY_AS_READ_DESCRIPTOR = msg({
	message: 'Mark community as read',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const MARK_CHANNEL_AS_READ_DESCRIPTOR = msg({
	message: 'Mark channel as read',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const START_A_GROUP_DM_DESCRIPTOR = msg({
	message: 'Start a group DM',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const TOGGLE_PINNED_MESSAGES_DESCRIPTOR = msg({
	message: 'Toggle pinned messages',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const TOGGLE_THE_INBOX_DESCRIPTOR = msg({
	message: 'Toggle the inbox',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const MARK_TOP_INBOX_CHANNEL_AS_READ_DESCRIPTOR = msg({
	message: 'Mark top inbox channel as read',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const MARK_ALL_INBOX_CHANNELS_AS_READ_DESCRIPTOR = msg({
	message: 'Mark all inbox channels as read',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const TOGGLE_THE_MEMBER_LIST_OR_VOICE_CHAT_DESCRIPTOR = msg({
	message: 'Toggle the member list or voice chat',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const TOGGLE_THE_EMOJI_PICKER_DESCRIPTOR = msg({
	message: 'Toggle the emoji picker',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const TOGGLE_THE_GIF_PICKER_DESCRIPTOR = msg({
	message: 'Toggle the GIF picker',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const TOGGLE_THE_STICKER_PICKER_DESCRIPTOR = msg({
	message: 'Toggle the sticker picker',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const SCROLL_CHAT_UP_DESCRIPTOR = msg({
	message: 'Scroll chat up',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const SCROLL_CHAT_DOWN_DESCRIPTOR = msg({
	message: 'Scroll chat down',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const JUMP_TO_THE_OLDEST_UNREAD_MESSAGE_DESCRIPTOR = msg({
	message: 'Jump to the oldest unread message',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const FOCUS_THE_TEXT_AREA_DESCRIPTOR = msg({
	message: 'Focus the text area',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const UPLOAD_A_FILE_DESCRIPTOR = msg({
	message: 'Upload a file',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const COPY_CHANNEL_LINK_DESCRIPTOR = msg({
	message: 'Copy channel link',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const TOGGLE_MUTE_DESCRIPTOR = msg({
	message: 'Toggle mute',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const ANSWER_THE_INCOMING_CALL_DESCRIPTOR = msg({
	message: 'Answer the incoming call',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const DECLINE_THE_INCOMING_CALL_DESCRIPTOR = msg({
	message: 'Decline the incoming call',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const START_A_CALL_IN_A_DM_OR_GROUP_DESCRIPTOR = msg({
	message: 'Start a call in a DM or group',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const TOGGLE_THE_SOUNDBOARD_DESCRIPTOR = msg({
	message: 'Toggle the soundboard',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const EXPAND_OR_COLLAPSE_COMPACT_CALL_VIEW_DESCRIPTOR = msg({
	message: 'Expand or collapse compact call view',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const OPEN_HELP_DESCRIPTOR = msg({
	message: 'Open help',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const SEARCH_MESSAGES_DESCRIPTOR = msg({
	message: 'Search messages',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const OPEN_THE_CONTEXT_MENU_DESCRIPTOR = msg({
	message: 'Open the context menu',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const OPEN_YOUR_SETTINGS_DESCRIPTOR = msg({
	message: 'Open your settings',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const OPEN_ACCOUNT_SWITCHER_DESCRIPTOR = msg({
	message: 'Open the account switcher',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const SWITCH_TO_NEXT_ACCOUNT_DESCRIPTOR = msg({
	message: 'Switch to the next account',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const SWITCH_TO_PREVIOUS_ACCOUNT_DESCRIPTOR = msg({
	message: 'Switch to the previous account',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const SWITCH_BACK_TO_LAST_ACCOUNT_DESCRIPTOR = msg({
	message: 'Switch back to the last account',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const JUMP_TO_NEWEST_OTHER_ACCOUNT_MENTION_DESCRIPTOR = msg({
	message: 'Jump to the newest mention on another account',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const SEARCH_OTHER_ACCOUNTS_DESCRIPTOR = msg({
	message: 'Search other accounts',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const SWITCH_TO_ACCOUNT_SLOT_DESCRIPTOR = msg({
	message: 'Switch to account {slot}',
	comment:
		'Keyboard shortcut action label shown in the keybind editor. {slot} is a numeric account position, such as 1.',
});
export const ZOOM_IN_DESCRIPTOR = msg({
	message: 'Zoom in',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const ZOOM_OUT_DESCRIPTOR = msg({
	message: 'Zoom out',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const RESET_ZOOM_DESCRIPTOR = msg({
	message: 'Reset zoom',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const BOOKMARK_MESSAGE_DESCRIPTOR = msg({
	message: 'Bookmark message',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const TOGGLE_EMBED_SUPPRESSION_DESCRIPTOR = msg({
	message: 'Toggle embed suppression',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const COPY_MESSAGE_LINK_DESCRIPTOR = msg({
	message: 'Copy message link',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const COPY_MESSAGE_ID_DESCRIPTOR = msg({
	message: 'Copy message ID',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const TOGGLE_SAVED_MEDIA_DESCRIPTOR = msg({
	message: 'Toggle saved media',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const SEND_VOICE_MESSAGE_DESCRIPTOR = msg({
	message: 'Send voice message',
	comment: 'Keyboard shortcut action label that opens the desktop voice message composer.',
});
export const PUSH_TO_TALK_DESCRIPTOR = msg({
	message: 'Push to talk',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const PUSH_TO_TALK_PRIORITY_DESCRIPTOR = msg({
	message: 'Push to talk (priority)',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const PUSH_TO_MUTE_DESCRIPTOR = msg({
	message: 'Push to mute',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const VOICE_ACTIVITY_PRIORITY_DESCRIPTOR = msg({
	message: 'Voice activity priority',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const TOGGLE_VOICE_ACTIVITY_DESCRIPTOR = msg({
	message: 'Toggle voice activity',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const TOGGLE_CAMERA_DESCRIPTOR = msg({
	message: 'Toggle camera',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const SWITCH_VOICE_CHANNEL_DESCRIPTOR = msg({
	message: 'Switch voice channel',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
export const DISCONNECT_FROM_VOICE_DESCRIPTOR = msg({
	message: 'Disconnect from voice',
	comment: 'Keyboard shortcut action label shown in the shortcuts list and keybind editor. Keep short, sentence case.',
});
